import React from "react";
import { useTheme } from "../../../../hook/useThemes";
import { formatNumber } from "../../../../services/utility/utils";
import CountDown from "../../../CountDown";
import TickerLine from "../CartConfirm/components/TickerLine";
import ContestOdd from "../ContestOdd";
import { useSelector } from "react-redux";
import "./style.scss";
import { ReactComponent as IconBet } from "../../../../assets/images/icon-coin-bet.svg";

type CardLiveProps = {
  contest?: any;
  type?: string;
};
export default function CardLive({ contest, type }: CardLiveProps) {
  const { lang, operatorId } = useTheme();

  const coinValue = useSelector((state: any) => state?.coinPrices?.BTC || 0);
  const priceChange = coinValue - contest?.livePrice;

  const hasEntry = !!contest?.position;

  return (
    <div
      className={`wrapper-content-cart-ticket wrapper-content-cart-ticket-${operatorId}
      ${type}-1
      `}
    >
      <div
        className={`contest-info contest-lock-price ${
          operatorId === 1 && "contest-lock-price-min"
        }`}
      >
        <div className="lock-price">
          <span>{lang?.locked_price || "Locked price"}</span>
          {contest?.livePrice > 0 && (
            <span className={`lock-price-value`}>
              $ {formatNumber(contest?.livePrice, 2)}
            </span>
          )}
          {!contest?.livePrice && (
            <span className="lock-price-value">
              {lang?.loading || "Loading"}...
            </span>
          )}
        </div>
        <div className="counter">
          <CountDown
            expiryTime={contest?.contestCloseTime}
            prefix={lang?.ends_in || "ends in"}
          />
        </div>
      </div>
      <div className="contest-info price-indicator">
        <TickerLine
          valueDf={contest?.livePrice}
          coinValue={coinValue}
          type={`${contest?.position || ""}`}
        />
      </div>
      <div
        className={`contest-info contest-odds ${
          operatorId === 1 && "contest-odds-min"
        }`}
      >
        <ContestOdd
          value={contest?.whitelabelRektOdds}
          side="below"
          animated={contest?.position === "rekt" && priceChange < 0}
          operatorId={operatorId}
        />
        <ContestOdd
          value={contest?.whitelabelMoonOdds}
          side="above"
          animated={contest?.position === "moon" && priceChange > 0}
          operatorId={operatorId}
        />
      </div>
      <div className={`contest-info price-change`}>
        <div className="value-price-change-down">
          {priceChange < 0 && (
            <>
              {lang?.down_by || "Down by"} $ {formatNumber(-priceChange, 2)}
            </>
          )}
        </div>
        <div className="value-price-change-up">
          {priceChange > 0 && (
            <>
              {lang?.up_by || "Up by"} $ {formatNumber(priceChange, 2)}
            </>
          )}
        </div>
      </div>
      {hasEntry && (
        <div className="contest-info entry-size">
          <div className="wrap-wager">
            {contest?.position === "rekt" && (
              <>
                <div className="wager">
                  <IconBet /> ${formatNumber(contest?.wager)}
                </div>
              </>
            )}
          </div>
          <div className="wrap-wager">
            {contest?.position === "moon" && (
              <>
                <div className="wager">
                  <IconBet /> ${formatNumber(contest?.wager)}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
